import { doc, $, RM, fmt, cssVar, rgbOf } from "./util.js";

// Home hero canvas: dots = creators; matched → shipped → posted, in daily waves.
export function initCrowd() {
  const cv = $("#crowd");
  if (!cv || !cv.getContext) return;
  const ctx = cv.getContext("2d");
  const card = cv.parentNode;
  const numEl = $("#crowdNum");
  const dayEl = $("#crowdDay");
  const TOTAL_POSTS = parseInt(card.dataset.total, 10) || 2140;
  const DAYS = 14, DAY_MS = 850, HOLD = 3200, SPEED = 0.55;
  const LET = "ABCDEFGHJKLMNPRSTVWZ";

  let W = 0, H = 0, dpr = 1, dots = [], origins = [];
  let running = false, visible = false, raf = 0, t0 = 0, last = 0, posters = 0;
  const mouse = { x: -999, y: -999 };
  let C = {};

  const readColors = () => {
    const pr = cssVar("--primary-color", "#F28C28");
    const se = cssVar("--secondary-color", "#1F8A84");
    const ac = cssVar("--accent-color", "#C9C3F2");
    const tx = cssVar("--text-color", "#1D1B2F");
    const sf = cssVar("--surface-color", "#FFFFFF");
    const [pR, pG, pB] = rgbOf(pr), [sR, sG, sB] = rgbOf(se), [aR, aG, aB] = rgbOf(ac);
    C = {
      primary: pr, accent: ac, text: tx, surface: sf,
      secondaryA: "rgba(" + sR + "," + sG + "," + sB + ",.95)",
      lineOn: "rgba(" + pR + "," + pG + "," + pB + ",.35)",
      lineOff: "rgba(" + aR + "," + aG + "," + aB + ",.14)",
      glow: "rgba(" + pR + "," + pG + "," + pB + ",.6)",
      ring: (a) => "rgba(" + pR + "," + pG + "," + pB + "," + a + ")",
    };
  };

  const init = () => {
    const r = card.getBoundingClientRect();
    if (!r.width) return false;
    readColors();
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = r.width;
    H = r.height;
    cv.width = W * dpr;
    cv.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const n = Math.max(300, Math.min(500, Math.round((W * H) / 820)));
    dots = [];
    for (let i = 0; i < n; i++) {
      const k = Math.random(), big = k > 0.93, mid = k > 0.68;
      const r0 = big ? 9 + Math.random() * 4 : mid ? 4 + Math.random() * 2 : 1.8 + Math.random() * 1.7;
      const postDay = Math.random() < 0.92 ? Math.floor(Math.pow(Math.random(), 0.9) * DAYS) : -1;
      dots.push({
        x: Math.random() * W, y: Math.random() * H,
        vx: (Math.random() - 0.5) * 0.012, vy: (Math.random() - 0.5) * 0.012,
        r: r0, big, ph: Math.random() * 6.28, postDay,
        shipDay: postDay < 0 ? Math.floor(Math.random() * 4) : Math.max(0, postDay - 1 - Math.floor(Math.random() * 3)),
        ini: big ? LET[i % LET.length] + LET[(i * 7) % LET.length] : "",
        lt: Infinity, sc: 1, nb: -1,
      });
    }
    for (let i = 0; i < n; i++) {
      let best = 1e9, bj = -1;
      for (let j = 0; j < n; j++) {
        if (i === j) continue;
        const dx = dots[i].x - dots[j].x, dy = dots[i].y - dots[j].y, d = dx * dx + dy * dy;
        if (d < best) { best = d; bj = j; }
      }
      dots[i].nb = best < 2500 ? bj : -1;
    }
    origins = [];
    for (let i = 0; i < DAYS; i++) origins.push({ x: Math.random() * W, y: Math.random() * H });
    posters = 0;
    dots.forEach((d) => { if (d.postDay >= 0) posters++; });
    return true;
  };

  const litTime = (d) => {
    if (d.postDay < 0) return Infinity;
    const o = origins[d.postDay];
    return d.postDay * DAY_MS + (Math.hypot(d.x - o.x, d.y - o.y) / SPEED) * 0.35;
  };

  const draw = (tc, dt, now) => {
    ctx.clearRect(0, 0, W, H);
    const n = dots.length;
    const day = Math.min(DAYS, Math.floor(tc / DAY_MS) + 1);
    let posted = 0, i, d;
    for (i = 0; i < n; i++) {
      d = dots[i];
      d.x += d.vx * dt + Math.sin(now * 0.0004 + d.ph) * 0.04;
      d.y += d.vy * dt + Math.cos(now * 0.00035 + d.ph) * 0.04;
      if (d.x < -15) d.x = W + 15; else if (d.x > W + 15) d.x = -15;
      if (d.y < -15) d.y = H + 15; else if (d.y > H + 15) d.y = -15;
      const dx = d.x - mouse.x, dy = d.y - mouse.y, dist = Math.sqrt(dx * dx + dy * dy);
      const target = dist < 110 ? 1 + 1.3 * (1 - dist / 110) : 1;
      d.sc += (target - d.sc) * Math.min(1, dt * 0.012);
      d.lt = litTime(d);
      if (tc >= d.lt) posted++;
    }
    ctx.lineWidth = 1;
    for (i = 0; i < n; i++) {
      d = dots[i];
      if (d.nb < 0) continue;
      const o = dots[d.nb], ddx = d.x - o.x, ddy = d.y - o.y;
      if (ddx * ddx + ddy * ddy > 3600) continue;
      ctx.strokeStyle = tc >= d.lt && tc >= o.lt ? C.lineOn : C.lineOff;
      ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(o.x, o.y); ctx.stroke();
    }
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    for (i = 0; i < n; i++) {
      d = dots[i];
      const r = d.r * d.sc, isP = tc >= d.lt, isS = tc >= d.shipDay * DAY_MS, age = tc - d.lt;
      if (isP && age < 900) {
        const k = age / 900;
        ctx.strokeStyle = C.ring((1 - k) * 0.9);
        ctx.lineWidth = 2;
        ctx.beginPath(); ctx.arc(d.x, d.y, r + 4 + k * 16, 0, 6.283); ctx.stroke();
      }
      ctx.fillStyle = isP ? C.primary : isS ? C.accent : C.secondaryA;
      if (isP && d.big) { ctx.shadowColor = C.glow; ctx.shadowBlur = 12; }
      ctx.beginPath(); ctx.arc(d.x, d.y, r, 0, 6.283); ctx.fill();
      ctx.shadowBlur = 0;
      if (d.big && r > 8) {
        ctx.fillStyle = isP || isS ? C.text : C.surface;
        ctx.font = "700 " + Math.round(r * 0.8) + "px " + cssVar("--font-text", "sans-serif");
        ctx.fillText(d.ini, d.x, d.y + 0.5);
      }
    }
    const target = Math.round((posted / Math.max(1, posters)) * TOTAL_POSTS);
    if (numEl && numEl.__v !== target) { numEl.__v = target; numEl.textContent = fmt(target); }
    if (dayEl && dayEl.__v !== day) { dayEl.__v = day; dayEl.textContent = day; }
  };

  const frame = (now) => {
    raf = 0;
    if (!running) return;
    const dt = Math.min(50, now - (last || now));
    last = now;
    let tc = now - t0;
    const cycle = DAYS * DAY_MS + HOLD + 900;
    if (tc > cycle) {
      t0 = now; tc = 0;
      origins.forEach((o) => { o.x = Math.random() * W; o.y = Math.random() * H; });
    }
    draw(tc, dt, now);
    raf = requestAnimationFrame(frame);
  };
  const start = () => { if (running || RM) return; running = true; last = 0; if (!raf) raf = requestAnimationFrame(frame); };
  const stop = () => { running = false; if (raf) { cancelAnimationFrame(raf); raf = 0; } };
  const boot = () => {
    if (!init()) return;
    t0 = performance.now();
    draw(DAYS * DAY_MS + HOLD, 0, 0); // never leave the card empty before the first rAF
    if (!RM && visible && !doc.hidden) start();
  };

  card.addEventListener("pointermove", (e) => {
    const r = card.getBoundingClientRect();
    mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
  }, { passive: true });
  card.addEventListener("pointerleave", () => { mouse.x = mouse.y = -999; });

  if ("IntersectionObserver" in window) {
    new IntersectionObserver((es) => {
      visible = es[0].isIntersecting;
      if (visible) { if (!dots.length) boot(); if (!doc.hidden) start(); } else stop();
    }).observe(card);
  } else { visible = true; boot(); }
  doc.addEventListener("visibilitychange", () => { if (doc.hidden) stop(); else if (visible) start(); });
  let rt;
  window.addEventListener("resize", () => {
    clearTimeout(rt);
    rt = setTimeout(() => { if (card.offsetParent) { stop(); boot(); } }, 200);
  });
}
